import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICategory } from "../../types/backend";
import { callFetchCategory } from "../../config/api";

interface IState {
  isFetching: boolean;
  meta: {
    current: any;
    pageSize: any;
    pages: any;
    total: any;
  };
  result: ICategory[];
}

// first, create thunk
export const fetchCategory = createAsyncThunk(
  "category/fetchCategory",
  async ({ query }: { query: string }) => {
    const response = await callFetchCategory(query);
    return response;
  }
);

const initialState: IState = {
  isFetching: true,
  meta: {
    current: 1,
    pageSize: 10,
    pages: 0,
    total: 0,
  },
  result: [],
};

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {},
  },

  extraReducers: (builder) => {
    builder.addCase(fetchCategory.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(fetchCategory.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchCategory.fulfilled, (state, action: any) => {
      if (action.payload && action.payload.data) {
        state.isFetching = false;
        state.meta = action.payload.data.meta;
        state.result = action.payload.data.result;
      }
    });
  },
});

export const { setActiveMenu } = categorySlice.actions;

export default categorySlice.reducer;
